import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import LockedField, { LockNotice } from "./LockedField";

const AddressSection = ({
  formData,
  formErrors,
  onInputChange,
  onAddressBlur,
  // A LOCK_NOTICES key, or null. The whole address locks together once a
  // contract is out, because the contract names the property.
  lock = null,
  onLockClick,
}) => {
  return (
    <div className="appointment-section">
      <div className="section-title-with-notice">
        <h6 className="section-title">Address</h6>
        <LockNotice notice={lock} />
      </div>
      <div className="section-fields">
        <LockedField notice={lock} onLockClick={onLockClick} showNotice={false}>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>
                  Address1 <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  value={formData.address1}
                  onChange={(e) => onInputChange("address1", e.target.value)}
                  onBlur={onAddressBlur}
                  isInvalid={!!formErrors.address1}
                />
                <Form.Control.Feedback type="invalid">
                  {formErrors.address1}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Address2</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.address2}
                  onChange={(e) => onInputChange("address2", e.target.value)}
                  isInvalid={!!formErrors.address2}
                />
                <Form.Control.Feedback type="invalid">
                  {formErrors.address2}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>
                  City <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  value={formData.city}
                  onChange={(e) => onInputChange("city", e.target.value)}
                  onBlur={onAddressBlur}
                  isInvalid={!!formErrors.city}
                />
                <Form.Control.Feedback type="invalid">
                  {formErrors.city}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>
                  State <span className="text-danger">*</span>
                </Form.Label>
                <Form.Select
                  value={formData.state}
                  onChange={(e) => onInputChange("state", e.target.value)}
                  onBlur={onAddressBlur}
                  isInvalid={!!formErrors.state}
                >
                  <option value="">Select State</option>
                  <option value="AL">Alabama</option>
                  <option value="AK">Alaska</option>
                  <option value="AZ">Arizona</option>
                  <option value="AR">Arkansas</option>
                  <option value="CA">California</option>
                  <option value="CO">Colorado</option>
                  <option value="CT">Connecticut</option>
                  <option value="DE">Delaware</option>
                  <option value="FL">Florida</option>
                  <option value="GA">Georgia</option>
                  <option value="HI">Hawaii</option>
                  <option value="ID">Idaho</option>
                  <option value="IL">Illinois</option>
                  <option value="IN">Indiana</option>
                  <option value="IA">Iowa</option>
                  <option value="KS">Kansas</option>
                  <option value="KY">Kentucky</option>
                  <option value="LA">Louisiana</option>
                  <option value="ME">Maine</option>
                  <option value="MD">Maryland</option>
                  <option value="MA">Massachusetts</option>
                  <option value="MI">Michigan</option>
                  <option value="MN">Minnesota</option>
                  <option value="MS">Mississippi</option>
                  <option value="MO">Missouri</option>
                  <option value="MT">Montana</option>
                  <option value="NE">Nebraska</option>
                  <option value="NV">Nevada</option>
                  <option value="NH">New Hampshire</option>
                  <option value="NJ">New Jersey</option>
                  <option value="NM">New Mexico</option>
                  <option value="NY">New York</option>
                  <option value="NC">North Carolina</option>
                  <option value="ND">North Dakota</option>
                  <option value="OH">Ohio</option>
                  <option value="OK">Oklahoma</option>
                  <option value="OR">Oregon</option>
                  <option value="PA">Pennsylvania</option>
                  <option value="RI">Rhode Island</option>
                  <option value="SC">South Carolina</option>
                  <option value="SD">South Dakota</option>
                  <option value="TN">Tennessee</option>
                  <option value="TX">Texas</option>
                  <option value="UT">Utah</option>
                  <option value="VT">Vermont</option>
                  <option value="VA">Virginia</option>
                  <option value="WA">Washington</option>
                  <option value="WV">West Virginia</option>
                  <option value="WI">Wisconsin</option>
                  <option value="WY">Wyoming</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {formErrors.state}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>
                  Postal Code <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  value={formData.postalCode}
                  onChange={(e) => onInputChange("postalCode", e.target.value)}
                  isInvalid={!!formErrors.postalCode}
                />
                <Form.Control.Feedback type="invalid">
                  {formErrors.postalCode}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
        </LockedField>
      </div>
    </div>
  );
};

export default AddressSection;
